// scheduleSidePanel.tsx
import './scheduleSidepanel.css';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SequenceComponent from './sequence_component/sequenceComponent';
import PdfViewButton from '../../../common/pdf_view_button/pdfViewButton';
import { useMonthNavigation } from '../../../../contexts/monthNavigationContext';

interface ScheduleSidePanel {
    isOpen: boolean;
    onEditingStateChange?: (isEditing: boolean) => void;
    panelData?: {
        rowData: any;
        colName: string;
        tableName: string;
    };
}

const ScheduleSidePanel: React.FC<ScheduleSidePanel> = ({
    isOpen,
    onEditingStateChange,
    panelData,
}) => {

    const { setMonthSelection } = useMonthNavigation();
    const navigate = useNavigate();
    const [isAnyItemEditing, setIsAnyItemEditing] = useState(false);
    
    // Callback to receive editing state from SequenceComponent
    const handleEditingStateChange = (isEditing: boolean) => {
        setIsAnyItemEditing(isEditing);
        onEditingStateChange?.(isEditing);
    };

    const handleNavigateToTicketData = () => {
        const rid = panelData?.rowData?.rid;
        const scheduleMonth = panelData?.rowData?.month;
        const scheduleYear = panelData?.rowData?.year;

        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 
                              'July', 'August', 'September', 'October', 'November', 'December'];
        const monthNumber = monthNames.indexOf(scheduleMonth) + 1;
        const monthYear = `${scheduleYear}-${String(monthNumber).padStart(2, '0')}`;
        const monthYearName = `${(scheduleMonth)} ${scheduleYear}`;

        setMonthSelection('crude_main_pickup', monthYear);
        navigate('/ticketdata', {
            state: {
                rid: rid,
                monthYearName: monthYearName,
                applyFilter: true
            }
        });
    };

    if (!isOpen) return null;

    return (
        <div className="scheduleSidePanel-mainContainer">
            <div className="scheduleSidePanel-header">
                <button
                    className="scheduleSidePanel-navigateButton"
                    onClick={handleNavigateToTicketData}
                >
                    <div>
                        Go to Ticket Data
                    </div>
                    <ArrowRight 
                        size={20}
                    />
                </button>
            </div>
            <div className="scheduleSidePanel-sequenceContainer">
                <SequenceComponent 
                    panelData={panelData}
                    onEditingStateChange={handleEditingStateChange}
                />
            </div>
            <div className="scheduleSidePanel-locationContainer"></div>
            <div className="scheduleSidePanel-pdfContainer">
                <PdfViewButton
                    ticketNumber={panelData?.rowData?.ticket_number || ''}
                    carrierName={panelData?.rowData?.carrier_name || ''}
                    producerName={panelData?.rowData?.producer_name || ''}
                />
            </div>
        </div>
    );
};

export default ScheduleSidePanel;
